<template>
    <div class="modern-form-container">
        <form class="modern-form">
            <!-- Antecedentes Personales -->
            <div class="form-section">
                <div class="section-title">
                    <i class="fas fa-user-circle"></i>
                    <span>Antecedentes Personales</span>
                </div>

                <div class="form-grid">
                    <div class="form-group">
                        <label class="form-label modern">
                            <span class="label-content">
                                <i class="fas fa-home"></i>
                                <span>Lugar de Residencia</span>
                            </span>
                        </label>
                        <MenuSelectedFull
v-model="formData.place_of_residence" label="" category="6"
                            apiurl="menuvalues" :can-edit-and-add="true" />
                    </div>

                    <div class="form-group">
                        <label class="form-label modern">
                            <span class="label-content">
                                <i class="fas fa-heart"></i>
                                <span>Estado Civil</span>
                            </span>
                        </label>
                        <MenuSelectedFull
v-model="formData.marital_status" label="" category="2"
                            :local-data="maritalGroups" :can-edit-and-add="false" />
                    </div>

                    <div class="form-group">
                        <label class="form-label modern">
                            <span class="label-content">
                                <i class="fas fa-tint"></i>
                                <span>Grupo Sanguíneo</span>
                            </span>
                        </label>
                        <MenuSelectedFull
v-model="formData.blood_group" label="" category="8" :local-data="bloodGroups"
                            :can-edit-and-add="false" />
                    </div>

                    <div class="form-group">
                        <label class="form-label modern">
                            <span class="label-content">
                                <i class="fas fa-graduation-cap"></i>
                                <span>Escolaridad</span>
                            </span>
                        </label>
                        <MenuSelectedFull
v-model="formData.education_level" label="" category="4"
                            :local-data="schoolGroups" :can-edit-and-add="false" />
                    </div>

                    <div class="form-group">
                        <label class="form-label modern">
                            <span class="label-content">
                                <i class="fas fa-clipboard-question"></i>
                                <span>Tipo de Interrogatorio</span>
                            </span>
                        </label>
                        <select v-model.number="formData.tipo_interrogatorio" class="form-control modern">
                            <option :value="0">Seleccionar...</option>
                            <option :value="1">Directo</option>
                            <option :value="2">Indirecto</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label modern">
                            <span class="label-content">
                                <i class="fas fa-briefcase"></i>
                                <span>Ocupación</span>
                            </span>
                        </label>
                        <MenuSelectedFull
v-model="formData.occupation" label="" category="7" apiurl="menuvalues"
                            :can-edit-and-add="true" />
                    </div>
                </div>
            </div>

            <!-- Vivienda -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-home"></i>
                    Datos de Vivienda
                </h4>
                <div class="fields-grid">
                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-house-user"></i>
                            Tipo de Habitación
                        </label>
                        <select v-model="formData.tipo_habitacion" class="form-control">
                            <option value="">Seleccionar...</option>
                            <option value="propia">Propia</option>
                            <option value="rentada">Rentada</option>
                            <option value="prestada">Prestada</option>
                            <option value="otro">Otro</option>
                        </select>
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-door-open"></i>
                            Número de Cuartos
                        </label>
                        <input
v-model.number="formData.numero_cuartos" type="number" class="form-control"
                            placeholder="Ej: 3" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-users"></i>
                            Número de Habitantes
                        </label>
                        <input
v-model.number="formData.numero_habitantes" type="number" class="form-control"
                            placeholder="Ej: 4" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-bed"></i>
                            Personas en Misma Habitación
                        </label>
                        <input
v-model.number="formData.personas_misma_habitacion" type="number" class="form-control"
                            placeholder="Ej: 2" />
                    </div>
                </div>
            </section>

            <!-- Alimentación - Ingestas por Semana -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-utensils"></i>
                    Ingestas por Semana
                </h4>
                <div class="fields-grid">
                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-glass-whiskey"></i>
                            Leche
                        </label>
                        <input
v-model.number="formData.ingestas_semana_leche" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-drumstick-bite"></i>
                            Carne
                        </label>
                        <input
v-model.number="formData.ingestas_semana_carne" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-egg"></i>
                            Huevo
                        </label>
                        <input
v-model.number="formData.ingestas_semana_huevo" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-apple-alt"></i>
                            Fruta
                        </label>
                        <input
v-model.number="formData.ingestas_semana_fruta" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-carrot"></i>
                            Verduras
                        </label>
                        <input
v-model.number="formData.ingestas_semana_verduras" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-seedling"></i>
                            Leguminosas
                        </label>
                        <input
v-model.number="formData.ingestas_semana_leguminosas" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-bread-slice"></i>
                            Cereales
                        </label>
                        <input
v-model.number="formData.ingestas_semana_cereales" type="number" class="form-control"
                            placeholder="Veces por semana" />
                    </div>
                </div>
            </section>

            <!-- Hábitos -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-hand-sparkles"></i>
                    Hábitos de Higiene
                </h4>
                <div class="fields-grid">
                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-utensils"></i>
                            Comidas por Día
                        </label>
                        <input
v-model.number="formData.comidas_por_dia" type="number" class="form-control"
                            placeholder="Ej: 3" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-shower"></i>
                            Baños Semanales
                        </label>
                        <input
v-model.number="formData.banio_semanal" type="number" class="form-control"
                            placeholder="Ej: 7" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-tshirt"></i>
                            Cambios de Ropa Semanales
                        </label>
                        <input
v-model.number="formData.cambios_ropa" type="number" class="form-control"
                            placeholder="Ej: 7" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-tooth"></i>
                            Cepillado Diario
                        </label>
                        <input
v-model.number="formData.cepillado_diario" type="number" class="form-control"
                            placeholder="Veces al día" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-teeth"></i>
                            Uso de Hilo Dental
                        </label>
                        <input
v-model.number="formData.uso_hilo_dental" type="number" class="form-control"
                            placeholder="Veces al día" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-spray-can"></i>
                            Uso de Enjuague Bucal
                        </label>
                        <input
v-model.number="formData.uso_enjuague_bucal" type="number" class="form-control"
                            placeholder="Veces al día" />
                    </div>
                </div>
            </section>

            <!-- Motivo de Consulta -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-stethoscope"></i>
                    Motivo de Consulta
                </h4>
                <div class="field-group">
                    <div class="editor-wrapper">
                        <quill-editor
v-model:value="formData.motivo_consulta" :options="$editorOptions"
                            class="editor modern" />
                        <div class="editor-footer">
                            <div class="editor-stats">
                                <span class="stat-item">
                                    <i class="fas fa-font"></i>
                                    {{ getTextLength(formData.motivo_consulta) }} caracteres
                                </span>
                                <span class="stat-item">
                                    <i class="fas fa-align-left"></i>
                                    {{ getWordCount(formData.motivo_consulta) }} palabras
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Vacunas -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-syringe"></i>
                    Esquema de Vacunación
                </h4>
                <div class="checkboxes-grid">
                    <div class="checkbox-group">
                        <input id="vacuna_bcg" v-model="formData.vacuna_bcg" type="checkbox" />
                        <label for="vacuna_bcg">
                            <i class="fas fa-shield-virus"></i>
                            BCG
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_hepatitis_c" v-model="formData.vacuna_hepatitis_c" type="checkbox" />
                        <label for="vacuna_hepatitis_c">
                            <i class="fas fa-shield-virus"></i>
                            Hepatitis C
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_pentavalente" v-model="formData.vacuna_pentavalente" type="checkbox" />
                        <label for="vacuna_pentavalente">
                            <i class="fas fa-shield-virus"></i>
                            Pentavalente
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_dpt" v-model="formData.vacuna_dpt" type="checkbox" />
                        <label for="vacuna_dpt">
                            <i class="fas fa-shield-virus"></i>
                            DPT
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_rotavirus" v-model="formData.vacuna_rotavirus" type="checkbox" />
                        <label for="vacuna_rotavirus">
                            <i class="fas fa-shield-virus"></i>
                            Rotavirus
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_neumococcica" v-model="formData.vacuna_neumococcica" type="checkbox" />
                        <label for="vacuna_neumococcica">
                            <i class="fas fa-shield-virus"></i>
                            Neumocócica
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input
id="vacuna_rs_sarampion_rubeola" v-model="formData.vacuna_rs_sarampion_rubeola"
                            type="checkbox" />
                        <label for="vacuna_rs_sarampion_rubeola">
                            <i class="fas fa-shield-virus"></i>
                            Sarampión-Rubéola
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_influenza" v-model="formData.vacuna_influenza" type="checkbox" />
                        <label for="vacuna_influenza">
                            <i class="fas fa-shield-virus"></i>
                            Influenza
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_srp" v-model="formData.vacuna_srp" type="checkbox" />
                        <label for="vacuna_srp">
                            <i class="fas fa-shield-virus"></i>
                            SRP
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_sabin" v-model="formData.vacuna_sabin" type="checkbox" />
                        <label for="vacuna_sabin">
                            <i class="fas fa-shield-virus"></i>
                            Sabin
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_papiloma" v-model="formData.vacuna_papiloma" type="checkbox" />
                        <label for="vacuna_papiloma">
                            <i class="fas fa-shield-virus"></i>
                            Papiloma
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="vacuna_otra" v-model="formData.vacuna_otra" type="checkbox" />
                        <label for="vacuna_otra">
                            <i class="fas fa-shield-virus"></i>
                            Otra
                        </label>
                    </div>
                </div>

                <div v-if="formData.vacuna_otra" class="field-group mt-3">
                    <label class="form-label">
                        <i class="fas fa-info-circle"></i>
                        Especificar Otra Vacuna
                    </label>
                    <input
v-model="formData.vacuna_otra_especificar" type="text" class="form-control"
                        placeholder="Nombre de la vacuna" />
                </div>
            </section>

            <!-- Alcohol -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-wine-bottle"></i>
                    Consumo de Alcohol
                </h4>
                <div class="fields-grid">
                    <div class="checkbox-group">
                        <input id="alcohol" v-model="formData.alcohol" type="checkbox" />
                        <label for="alcohol">
                            <i class="fas fa-wine-glass-alt"></i>
                            Consume alcohol
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="alcohol_ex_bebedor" v-model="formData.alcohol_ex_bebedor" type="checkbox" />
                        <label for="alcohol_ex_bebedor">
                            <i class="fas fa-ban"></i>
                            Ex bebedor
                        </label>
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-calendar-alt"></i>
                            Años de Uso
                        </label>
                        <input
v-model.number="formData.alcohol_anios_uso" type="number" class="form-control"
                            placeholder="Años" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-clock"></i>
                            Último Uso
                        </label>
                        <DatePicker
v-model="formData.alcohol_ultimo_uso" placeholder="Seleccionar fecha"
                            :max-date="new Date().toISOString().split('T')[0]" error-field-name="alcohol_ultimo_uso" />
                    </div>
                </div>
            </section>

            <!-- Tabaco -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-smoking"></i>
                    Consumo de Tabaco
                </h4>
                <div class="fields-grid">
                    <div class="checkbox-group">
                        <input id="tabaco" v-model="formData.tabaco" type="checkbox" />
                        <label for="tabaco">
                            <i class="fas fa-smoking"></i>
                            Consume tabaco
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input id="tabaco_ex_fumador" v-model="formData.tabaco_ex_fumador" type="checkbox" />
                        <label for="tabaco_ex_fumador">
                            <i class="fas fa-ban"></i>
                            Ex fumador
                        </label>
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-calendar-alt"></i>
                            Años de Uso
                        </label>
                        <input
v-model.number="formData.tabaco_anios_uso" type="number" class="form-control"
                            placeholder="Años" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-clock"></i>
                            Último Uso
                        </label>
                        <DatePicker
v-model="formData.tabaco_ultimo_uso" placeholder="Seleccionar fecha"
                            :max-date="new Date().toISOString().split('T')[0]" error-field-name="tabaco_ultimo_uso" />
                    </div>
                </div>
            </section>

            <!-- Estupefacientes -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-pills"></i>
                    Consumo de Estupefacientes
                </h4>
                <div class="fields-grid">
                    <div class="checkbox-group">
                        <input id="estupefacientes" v-model="formData.estupefacientes" type="checkbox" />
                        <label for="estupefacientes">
                            <i class="fas fa-pills"></i>
                            Consume estupefacientes
                        </label>
                    </div>

                    <div class="checkbox-group">
                        <input
id="estupefacientes_ex_consumidor" v-model="formData.estupefacientes_ex_consumidor"
                            type="checkbox" />
                        <label for="estupefacientes_ex_consumidor">
                            <i class="fas fa-ban"></i>
                            Ex consumidor
                        </label>
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-calendar-alt"></i>
                            Años de Uso
                        </label>
                        <input
v-model.number="formData.estupefacientes_anios_uso" type="number" class="form-control"
                            placeholder="Años" />
                    </div>

                    <div class="field-group">
                        <label class="form-label">
                            <i class="fas fa-clock"></i>
                            Último Uso
                        </label>
                        <DatePicker
v-model="formData.estupefacientes_ultimo_uso" placeholder="Seleccionar fecha"
                            :max-date="new Date().toISOString().split('T')[0]"
                            error-field-name="estupefacientes_ultimo_uso" />
                    </div>
                </div>
            </section>

            <!-- Alergias y Medicamentos -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-allergies"></i>
                    Alergias y Medicamentos
                </h4>
                <div class="field-group mb-3">
                    <label class="form-label">
                        <i class="fas fa-exclamation-triangle"></i>
                        Alergias (especificar)
                    </label>
                    <div class="editor-wrapper">
                        <quill-editor
v-model:value="formData.alergias_especificar" :options="$editorOptions"
                            class="editor modern" />
                        <div class="editor-footer">
                            <div class="editor-stats">
                                <span class="stat-item">
                                    <i class="fas fa-font"></i>
                                    {{ getTextLength(formData.alergias_especificar) }} caracteres
                                </span>
                                <span class="stat-item">
                                    <i class="fas fa-align-left"></i>
                                    {{ getWordCount(formData.alergias_especificar) }} palabras
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field-group">
                    <label class="form-label">
                        <i class="fas fa-prescription-bottle-alt"></i>
                        Medicamentos y Fármacos
                    </label>
                    <div class="editor-wrapper">
                        <quill-editor
v-model:value="formData.medicamentos_y_farmacos" :options="$editorOptions"
                            class="editor modern" />
                        <div class="editor-footer">
                            <div class="editor-stats">
                                <span class="stat-item">
                                    <i class="fas fa-font"></i>
                                    {{ getTextLength(formData.medicamentos_y_farmacos) }} caracteres
                                </span>
                                <span class="stat-item">
                                    <i class="fas fa-align-left"></i>
                                    {{ getWordCount(formData.medicamentos_y_farmacos) }} palabras
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Actividad Sexual -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-heart"></i>
                    Actividad y Preferencia Sexual
                </h4>
                <div class="field-group">
                    <div class="editor-wrapper">
                        <quill-editor
v-model:value="formData.actividad_y_preferencia_sexual" :options="$editorOptions"
                            class="editor modern" />
                        <div class="editor-footer">
                            <div class="editor-stats">
                                <span class="stat-item">
                                    <i class="fas fa-font"></i>
                                    {{ getTextLength(formData.actividad_y_preferencia_sexual) }} caracteres
                                </span>
                                <span class="stat-item">
                                    <i class="fas fa-align-left"></i>
                                    {{ getWordCount(formData.actividad_y_preferencia_sexual) }} palabras
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Odontogramas -->
            <section class="dentistry-section">
                <h4 class="subsection-title">
                    <i class="fas fa-teeth"></i>
                    Odontogramas
                </h4>
                <div class="canvas-grid">
                    <div class="canvas-card">
                        <h5 class="canvas-title">Odontograma Superior</h5>
                        <BackgroundCanvas
key="odontograma-superior"
                            :initial-shapes="parsedShapes(formData.odontograma_superior)"
                            imagepath="/img/odontograma_superior.png"
                            @save-shapes="newShapes => handleSaveShapes(newShapes, 'odontograma_superior')" />
                    </div>
                    <div class="canvas-card">
                        <h5 class="canvas-title">Odontograma Inferior</h5>
                        <BackgroundCanvas
key="odontograma-inferior"
                            :initial-shapes="parsedShapes(formData.odontograma_inferior)"
                            imagepath="/img/odontograma_inferior.png"
                            @save-shapes="newShapes => handleSaveShapes(newShapes, 'odontograma_inferior')" />
                    </div>
                </div>
            </section>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import api from '@/services/api';
import BackgroundCanvas from '@/components/BackgroundCanvas.vue';
import MenuSelectedFull from '@/components/MenuSelectedFull.vue';
import DatePicker from '@/components/DatePicker.vue';
import { maritalGroups, schoolGroups, bloodGroups } from '@/data/menuvalues';
import { useCanvasShapes } from '@/composables/useCanvasShapes';

const props = defineProps({
    patientRecord: {
        type: Object,
        required: true
    }
});

// Funciones para contar caracteres y palabras
const getTextLength = (html) => {
    if (!html) return 0;
    const text = html.replace(/<[^>]*>/g, '');
    return text.length;
};

const getWordCount = (html) => {
    if (!html) return 0;
    const text = html.replace(/<[^>]*>/g, '').trim();
    if (!text) return 0;
    return text.split(/\s+/).length;
};

// FormData reactivo
const formData = ref({
    // Antecedentes - usando los mismos campos que Historia Clínica General
    place_of_residence: 0, // Lugar de residencia (menu category 6) → estado en BD
    marital_status: 0, // Estado Civil (menu category 2) → estado_civil en BD
    blood_group: 0, // Grupo Sanguíneo (menu category 8) → tipo_sanguineo en BD
    education_level: 0, // Escolaridad (menu category 4) → escolaridad en BD
    occupation: 0, // Ocupación (menu category 7) → ocupacion en BD
    tipo_interrogatorio: 0, // Tipo de Interrogatorio (integer) → tipo_interrogatorio en BD

    // Vivienda
    tipo_habitacion: '',
    numero_cuartos: null,
    numero_habitantes: null,
    personas_misma_habitacion: null,

    // Ingestas
    ingestas_semana_leche: null,
    ingestas_semana_carne: null,
    ingestas_semana_huevo: null,
    ingestas_semana_fruta: null,
    ingestas_semana_verduras: null,
    ingestas_semana_leguminosas: null,
    ingestas_semana_cereales: null,

    // Hábitos
    comidas_por_dia: null,
    banio_semanal: null,
    cambios_ropa: null,
    cepillado_diario: null,
    uso_hilo_dental: null,
    uso_enjuague_bucal: null,

    // Motivo
    motivo_consulta: '',

    // Vacunas
    vacuna_bcg: false,
    vacuna_hepatitis_c: false,
    vacuna_pentavalente: false,
    vacuna_dpt: false,
    vacuna_rotavirus: false,
    vacuna_neumococcica: false,
    vacuna_rs_sarampion_rubeola: false,
    vacuna_influenza: false,
    vacuna_srp: false,
    vacuna_sabin: false,
    vacuna_papiloma: false,
    vacuna_otra: false,
    vacuna_otra_especificar: '',

    // Alcohol
    alcohol: false,
    alcohol_ex_bebedor: false,
    alcohol_anios_uso: null,
    alcohol_ultimo_uso: '',

    // Tabaco
    tabaco: false,
    tabaco_ex_fumador: false,
    tabaco_anios_uso: null,
    tabaco_ultimo_uso: '',

    // Estupefacientes
    estupefacientes: false,
    estupefacientes_ex_consumidor: false,
    estupefacientes_anios_uso: null,
    estupefacientes_ultimo_uso: '',

    // Otros
    alergias_especificar: '',
    medicamentos_y_farmacos: '',
    actividad_y_preferencia_sexual: '',

    // Odontogramas
    odontograma_superior: '',
    odontograma_inferior: ''
});

// Usar el composable para manejar shapes de canvas
const { parsedShapes, createShapesHandler } = useCanvasShapes();

// Crear el handler para guardar shapes
const handleSaveShapes = createShapesHandler({
    formData,
    patientId: props.patientRecord.id,
    endpoint: '/pacientes/{id}/dentistry',
    logIcon: '🦷',
    successMessage: 'Odontograma guardado correctamente'
});

const loadData = async () => {
    try {
        const response = await api.get(`/pacientes/${props.patientRecord.id}/dentistry`);
        const data = response.data.data || {};

        // Mapear campos de la BD al frontend con conversión a números
        if (data.estado !== undefined) {
            formData.value.place_of_residence = Number(data.estado) || 0;
        }
        if (data.estado_civil !== undefined) {
            formData.value.marital_status = Number(data.estado_civil) || 0;
        }
        if (data.tipo_sanguineo !== undefined) {
            formData.value.blood_group = Number(data.tipo_sanguineo) || 0;
        }
        if (data.escolaridad !== undefined) {
            formData.value.education_level = Number(data.escolaridad) || 0;
        }
        if (data.ocupacion !== undefined) {
            formData.value.occupation = Number(data.ocupacion) || 0;
        }
        if (data.tipo_interrogatorio !== undefined) {
            formData.value.tipo_interrogatorio = Number(data.tipo_interrogatorio) || 0;
        }

        // Asignar el resto de los campos
        Object.assign(formData.value, data);

        console.log('📥 Datos de odontología cargados:', formData.value);
    } catch (error) {
        if (error.response?.status !== 404) {
            console.error('Error al cargar historia odontológica:', error);
        }
    }
};

let saveTimeout = null;
const saveData = async () => {
    console.log('🔔 saveData llamado, formData:', JSON.stringify(formData.value, null, 2));

    if (saveTimeout) {
        clearTimeout(saveTimeout);
    }

    saveTimeout = setTimeout(async () => {
        try {
            // Mapear campos del frontend a la estructura de la BD
            const dataToSave = {
                ...formData.value,
                // Mapeo de campos con nombres diferentes en BD
                estado: Number(formData.value.place_of_residence) || 0,
                estado_civil: Number(formData.value.marital_status) || 0,
                tipo_sanguineo: Number(formData.value.blood_group) || 0,
                escolaridad: Number(formData.value.education_level) || 0,
                ocupacion: Number(formData.value.occupation) || 0,
                tipo_interrogatorio: Number(formData.value.tipo_interrogatorio) || 0
            };

            console.log('🔍 VALORES ANTES DE MAPEAR:');
            console.log('  place_of_residence:', formData.value.place_of_residence, '→ estado:', dataToSave.estado);
            console.log('  marital_status:', formData.value.marital_status, '→ estado_civil:', dataToSave.estado_civil);
            console.log('  blood_group:', formData.value.blood_group, '→ tipo_sanguineo:', dataToSave.tipo_sanguineo);
            console.log('  education_level:', formData.value.education_level, '→ escolaridad:', dataToSave.escolaridad);
            console.log('  occupation:', formData.value.occupation, '→ ocupacion:', dataToSave.ocupacion);
            console.log('  tipo_interrogatorio:', formData.value.tipo_interrogatorio, '→', dataToSave.tipo_interrogatorio);

            // Eliminar las versiones del frontend para evitar duplicados
            delete dataToSave.place_of_residence;
            delete dataToSave.marital_status;
            delete dataToSave.blood_group;
            delete dataToSave.education_level;
            delete dataToSave.occupation;

            console.log('📤 Enviando a API:', JSON.stringify(dataToSave, null, 2));
            const response = await api.post(`/pacientes/${props.patientRecord.id}/dentistry`, dataToSave);
            console.log('✅ Historia odontológica guardada automáticamente', response.data);
        } catch (error) {
            console.error('❌ Error al guardar historia odontológica:', error);
            console.error('❌ Detalles del error:', error.response?.data);
        }
    }, 1000); // Espera 1 segundo después del último cambio
};

watch(formData, saveData, { deep: true });

watch(() => props.patientRecord.id, (newId, oldId) => {
    if (newId !== oldId) {
        console.log('🔄 Cambio de paciente detectado en PatientDentistry:', oldId, '->', newId);
        formData.value = {
            place_of_residence: 0,
            marital_status: 0,
            blood_group: 0,
            education_level: 0,
            occupation: 0,
            tipo_interrogatorio: 0,
            tipo_habitacion: '',
            numero_cuartos: null,
            numero_habitantes: null,
            personas_misma_habitacion: null,
            ingestas_semana_leche: null,
            ingestas_semana_carne: null,
            ingestas_semana_huevo: null,
            ingestas_semana_fruta: null,
            ingestas_semana_verduras: null,
            ingestas_semana_leguminosas: null,
            ingestas_semana_cereales: null,
            comidas_por_dia: null,
            banio_semanal: null,
            cambios_ropa: null,
            cepillado_diario: null,
            uso_hilo_dental: null,
            uso_enjuague_bucal: null,
            motivo_consulta: '',
            vacuna_bcg: false,
            vacuna_hepatitis_c: false,
            vacuna_pentavalente: false,
            vacuna_dpt: false,
            vacuna_rotavirus: false,
            vacuna_neumococcica: false,
            vacuna_rs_sarampion_rubeola: false,
            vacuna_influenza: false,
            vacuna_srp: false,
            vacuna_sabin: false,
            vacuna_papiloma: false,
            vacuna_otra: false,
            vacuna_otra_especificar: '',
            alcohol: false,
            alcohol_ex_bebedor: false,
            alcohol_anios_uso: null,
            alcohol_ultimo_uso: '',
            tabaco: false,
            tabaco_ex_fumador: false,
            tabaco_anios_uso: null,
            tabaco_ultimo_uso: '',
            estupefacientes: false,
            estupefacientes_ex_consumidor: false,
            estupefacientes_anios_uso: null,
            estupefacientes_ultimo_uso: '',
            alergias_especificar: '',
            medicamentos_y_farmacos: '',
            actividad_y_preferencia_sexual: ''
        };
        loadData();
    }
});

onMounted(() => {
    loadData();
});
</script>

<style scoped>
.modern-form-container {
    --accent: #3b82f6;
    --accent-strong: #2563eb;
    --accent-soft: #eff6ff;
    --border: #e2e8f0;
    --surface: #ffffff;
    --muted-surface: #f8fafc;
    --text: #334155;
    --muted-text: #64748b;
    --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    margin-bottom: 24px;
    background: var(--surface);
    border-radius: 16px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow);
    overflow: hidden;
}

.form-header {
    background: white;
    border-bottom: 1px solid var(--border);
    padding: 1.5rem;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
}

.title-section {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.icon-wrapper {
    background: var(--accent-soft);
    border-radius: 12px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    color: var(--accent);
}

.form-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--text);
    letter-spacing: -0.025em;
}

.form-subtitle {
    margin: 0.25rem 0 0;
    color: var(--muted-text);
    font-size: 0.875rem;
}

.modern-form {
    background: var(--surface);
    padding: 1.5rem;
}

.form-section {
    background: var(--muted-surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.section-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--text);
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid var(--border);
}

.section-title i {
    color: var(--accent);
    font-size: 1.25rem;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.25rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-label.modern {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    color: var(--text);
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
}

.label-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.label-content i {
    color: var(--accent);
    width: 1.25rem;
    text-align: center;
    font-size: 0.875rem;
}

.form-control.modern {
    width: 100%;
    padding: 0.625rem 0.875rem;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
    background: white;
    color: var(--text);
}

.form-control.modern:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-soft);
}

.form-control.modern:hover {
    border-color: #cbd5e1;
}

select.form-control.modern {
    cursor: pointer;
}

input[type="number"].form-control.modern {
    -moz-appearance: textfield;
}

input[type="number"].form-control.modern::-webkit-outer-spin-button,
input[type="number"].form-control.modern::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.editor.modern {
    border: 1px solid var(--border);
    border-radius: 8px;
    background: white;
    transition: all 0.2s ease;
}

.editor.modern:hover {
    border-color: #cbd5e1;
}

.editor.modern:focus-within {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-soft);
}

.editor.modern :deep(.ql-container) {
    border: none;
    font-size: 0.875rem;
    min-height: 150px;
}

.editor.modern :deep(.ql-editor) {
    min-height: 150px;
    padding: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    line-height: 1.6;
    color: var(--text);
}

.editor.modern :deep(.ql-editor.ql-blank::before) {
    color: var(--muted-text);
    font-style: normal;
    left: 1rem;
}

.editor.modern :deep(.ql-toolbar) {
    border: none;
    border-bottom: 1px solid var(--border);
    background: var(--muted-surface);
    padding: 0.625rem;
    border-radius: 8px 8px 0 0;
}

.editor-wrapper {
    position: relative;
    border: 1px solid var(--border);
    border-radius: 8px;
    overflow: hidden;
    background: white;
    transition: all 0.3s ease;
}

.editor-wrapper:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.editor-wrapper:focus-within {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-soft);
}

.editor-wrapper .editor.modern {
    border: none;
}

.editor-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.625rem 1rem;
    background: var(--muted-surface);
    border-top: 1px solid var(--border);
}

.editor-stats {
    display: flex;
    gap: 1.25rem;
    font-size: 0.75rem;
    color: var(--muted-text);
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 0.375rem;
}

.stat-item i {
    font-size: 0.6875rem;
    color: #94a3b8;
}

/* Estilos específicos para dentistry */
.checkboxes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.checkbox-group {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.75rem;
    background: white;
    border: 1px solid var(--border);
    border-radius: 8px;
    transition: all 0.2s ease;
}

.checkbox-group:hover {
    border-color: var(--accent);
    box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);
}

.checkbox-group input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--accent);
}

.checkbox-group label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    margin: 0;
    font-size: 0.875rem;
    color: var(--text);
    font-weight: 500;
    user-select: none;
}

.checkbox-group label i {
    color: var(--accent);
    font-size: 0.875rem;
}

/* Secciones adicionales usando el mismo patrón */
.dentistry-section {
    background: var(--muted-surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.subsection-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--text);
    margin-bottom: 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid var(--border);
}

.subsection-title i {
    color: var(--accent);
    font-size: 1.25rem;
}

.fields-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.25rem;
}

.field-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    color: var(--text);
    font-size: 0.875rem;
}

.form-label i {
    color: var(--accent);
    width: 1.25rem;
    text-align: center;
    font-size: 0.875rem;
}

.form-control {
    width: 100%;
    padding: 0.625rem 0.875rem;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
    background: white;
}

.form-control:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-soft);
}

.form-control:hover {
    border-color: #cbd5e1;
}

select.form-control {
    cursor: pointer;
}

input[type="number"].form-control {
    -moz-appearance: textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.mt-3 {
    margin-top: 1rem;
}

/* Responsive */
@media (max-width: 768px) {
    .form-grid {
        grid-template-columns: 1fr;
    }

    .fields-grid {
        grid-template-columns: 1fr;
    }

    .checkboxes-grid {
        grid-template-columns: 1fr;
    }
}

/* Canvas para Odontogramas */
.canvas-grid {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1rem;
}

.canvas-card {
    background: white;
    border-radius: 12px;
    padding: 1.25rem;
    border: 1px solid var(--border);
    transition: all 0.3s ease;
}

.canvas-card:hover {
    border-color: var(--accent);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.canvas-title {
    font-size: 1rem;
    font-weight: 600;
    color: var(--text);
    margin: 0 0 12px 0;
    text-align: center;
}

.canvas-card :deep(.background-canvas) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.canvas-card :deep(.drawing-canvas) {
    width: 100% !important;
    height: auto !important;
    max-height: 280px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    object-fit: contain;
}

@media (max-width: 992px) {
    .canvas-grid {
        grid-template-columns: 1fr;
    }
}
</style>
